var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"internal-link--container",on:{"mouseover":_vm.setHover,"mouseleave":_vm.endHover}},[_c('router-link',{class:_vm.className,style:(_vm.textShadow),attrs:{"to":_vm.to}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }